import React from 'react';
import PropTypes from 'prop-types';

class HowInfoPane extends React.Component {

  constructor(props){
    super(props);

    let temp = true;
    if (props.inForm !== true) {
      temp = false
    }
    this.state = {
      inForm: temp
    }
  }

  componentWillMount () {
    let temp = "";
    if (this.state.inForm) {
      temp = "inForm";
    }
    this.setState(() => {
      return {
        mainClass: temp
      };
    });
  }
  render(){
    return (
      <div className={"hdiw-wrapper " + this.state.mainClass}>
        <h2 className="vk-title hdiw-title ">So how does it work?</h2>
        <div className="genericUI-line"></div>
        <div className="hdiw-panels-container">
          <div className="hdiw-panel">
            <i className="fa fa-qrcode hdiw-icon" aria-hidden="true">
            </i><div className="hdiw-panel-text">
              <h5 className="hdiw-panel-title">VizCodes</h5>
              <p className="hdiw-panel-para">Use our easy to use, <b>mobile friendly</b> website to register an account.  Enter the information that you wish to link to your VizCode. You can choose what information you would like the finder to see. Many of our parents include any medical conditions, allergies and a parent contact number.</p>
            </div>
          </div>
          <div className="hdiw-panel">
            <i className="fa fa-user hdiw-icon" aria-hidden="true">
            </i><div className="hdiw-panel-text">
              <h5 className="hdiw-panel-title">Your VK Product</h5>
              <p className="hdiw-panel-para">Choose from a range of items- from t-shirts and hoodies, to wrist bands and high- Viz vests. Your product will be printed with your unique VizCode and delivered to you. The code will be printed with instructions to scan with any mobile phone for emergency contact information.</p>
            </div>
          </div>
          <div className="hdiw-panel last">
            <i className="fa fa-bell hdiw-icon" aria-hidden="true">

            </i><div className="hdiw-panel-text">
              <h5 className="hdiw-panel-title">When Your Child{"'"}s Vizcode is Scanned</h5>
              <p className="hdiw-panel-para">You will receive a notification by SMS or direct from the app. You will receive a map with their location and an opportunity to communicate with the person that has scanned your VizCode.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


HowInfoPane.propTypes = {
  inForm: PropTypes.bool
}

HowInfoPane.defaultProps = {
  inForm: false
};

export default HowInfoPane;



// WEBPACK FOOTER //
// ./src/components/home/HowInfoPane.js